import { render } from "./SeratoLogo.svg?vue&type=template&id=45572bba"
const script = {}
script.render = render

export default script